// #169 / #170 — the box and the stop position of a recurring task.

// CT boxes are named "Caisse 292" with external ref "292": don't print the
// number twice.
export function boxLabel(box) {
  if (!box) return '';
  const ref = box.externalRef;
  if (!ref || String(box.name || '').includes(ref)) return box.name || ref;
  return `${box.name} (${ref})`;
}

// Table sorter: by tournée (the first type tag, e.g. CT-T17), then by
// position inside it; tasks without a position last in their tournée.
export function byPosition(a, b) {
  const ta = (a.defaultTypes || [])[0] || '';
  const tb = (b.defaultTypes || [])[0] || '';
  const pa = a.position ?? Number.MAX_SAFE_INTEGER;
  const pb = b.position ?? Number.MAX_SAFE_INTEGER;
  return ta.localeCompare(tb) || pa - pb;
}
